export const faqItems = [
  {
    question: "¿Cuánto tarda realmente?",
    answer:
      "10 minutos de configuración. Si tienes tus miembros en Excel, los importas en 30.",
  },
  {
    question: "¿Pueden usarlo mis coordinadores solos?",
    answer:
      "Diseñado para que lo usen sin que tengas que recordárselo. Si usan WhatsApp, pueden usarlo.",
  },
  {
    question: "¿Qué pasa si cancelamos?",
    answer:
      "Tus datos son tuyos siempre. Te los exportamos en Excel ese mismo día.",
  },
  {
    question: "¿Funciona en el móvil?",
    answer:
      "Pensado para móvil primero. Sin instalar nada, desde cualquier teléfono.",
  },
  {
    question: "¿Puedo adaptarlo a mi iglesia?",
    answer:
      "El sistema se adapta a ti, no al revés. Personaliza según cómo funciona la iglesia.",
  },
  {
    question: "¿El soporte es en español de verdad?",
    answer:
      "Sí. Personas reales, no bots. Respondemos en menos de 24 horas.",
  },
  {
    question: "¿Están seguros los datos de mi congregación?",
    answer:
      "Encriptados y con copias automáticas diarias. Solo tu equipo tiene acceso, siempre.",
  },
  {
    question: "¿Registrar todo no es demasiado control?",
    answer:
      "Registrar no es vigilar, es cuidar. Saber quién falta es pastoreo, no control.",
  },
  {
    question: "¿Quién puede ver los datos de mi congregación?",
    answer:
      "Solo las personas que tú autorices. Cada iglesia tiene su propio espacio aislado. Ni otras iglesias ni nosotros accedemos a tus datos sin tu permiso.",
  },
  {
    question: "¿Cumplen con el RGPD y la protección de datos?",
    answer:
      "Sí. Operamos bajo la normativa europea de protección de datos. Los datos de tu congregación son tuyos y puedes exportarlos o eliminarlos en cualquier momento.",
  },
  {
    question: "¿Qué pasa con mis datos si cancelo?",
    answer:
      "Tus datos permanecen disponibles durante 30 días tras la cancelación. Puedes exportarlos en ese periodo. Después se eliminan de forma permanente.",
  },
  {
    question: "¿Hacen copias de seguridad?",
    answer:
      "Sí. Realizamos copias de seguridad automáticas cada día. Si algo sale mal, tus datos están protegidos.",
  },
];
